import React, { useEffect, useState } from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useChiusureDialogs } from "../../provider/dialog_chiusure_provider";
import { useTeli } from "../../provider/teli_provider";
import { Optional, TeloType } from "../../../../../models/pergola_configuration";

interface Props {
  tipoTelo: TeloType;
  codiceTelo: string;
  accessori: Optional[];
  handleChange: (field: string, value: any) => void; // Redux style
  lato: "Retro" | "Fronte" | "Destra" | "Sinistra";
}

export const TendeZip: React.FC<Props> = ({
  tipoTelo,
  codiceTelo,
  accessori,
  handleChange
}) => {
  const dialogs = useChiusureDialogs();
  const teliProvider = useTeli();
  const [imgElement, setImgElement] = useState<JSX.Element | null>(null);

  useEffect(() => {
    if (codiceTelo && teliProvider) {
      teliProvider.getTeloImgPreview(codiceTelo).then((img) => {
        setImgElement(img ? <img src={img.src} alt="" style={{ width: 32, height: 32 }} /> : null);
      });
    } else {
      setImgElement(null);
    }
  }, [codiceTelo, teliProvider]);

  return (
    <>
      {/* Select Tipo Telo */}
      <FormControl fullWidth className="mt-3">
        <InputLabel id="tipo_telo_label">Tipo di Telo</InputLabel>
        <Select
          labelId="tipo_telo_label"
          id="tipo_telo"
          value={tipoTelo || TeloType.teloOscurantePOLI}
          onChange={(e) => handleChange("tipo_telo", e.target.value)}
        >
          <MenuItem value={TeloType.teloCristal}>Telo Cristal</MenuItem>
          <MenuItem value={TeloType.teloSemioscurantePVC}>Telo Semioscurante PVC</MenuItem>
          <MenuItem value={TeloType.teloSemioscurantePOLI}>Telo Semioscurante POLI</MenuItem>
          <MenuItem value={TeloType.teloOscurantePOLI}>Telo Oscurante POLI</MenuItem>
        </Select>
      </FormControl>

      {/* TextField Codice Telo */}
      {tipoTelo !== TeloType.teloCristal && (
        <TextField
          fullWidth
          className="mt-2"
          label={!codiceTelo ? "Seleziona telo" : ""}
          value={teliProvider.getTeloName(codiceTelo || "") || ""}
          InputProps={{
            readOnly: true,
            startAdornment: codiceTelo ? <InputAdornment position="start">{imgElement}</InputAdornment> : null,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => {
                    if (!teliProvider?.list.length) {
                      alert("I teli non sono ancora disponibili, riprova più tardi.");
                      return;
                    }
                    // Dialog selezione telo
                    const dialogsMap = {
                      [TeloType.teloSemioscurantePVC]: dialogs?.selectTeloSemioscurantePVC,
                      [TeloType.teloSemioscurantePOLI]: dialogs?.selectTeloSemioscurantePOLI,
                      [TeloType.teloOscurantePOLI]: dialogs?.selectTeloOscurante
                    };
                    const dialogFn = dialogsMap[tipoTelo];
                    dialogFn?.({
                      teli: teliProvider.list,
                      selectedTelo: codiceTelo,
                      onConfirm: (code: string | null) => {
                        if (code) handleChange("codice_telo", code);
                      }
                    });
                  }}
                >
                  <OpenInNewIcon style={{ color: "black" }} />
                </IconButton>
              </InputAdornment>
            )
          }}
        />
      )}

      {/* Optional 
      <h6 className="text-primary mt-4">Optional</h6>
      {[
        { sku: "TACCA03", name: "Ricevitore radio integrato nel motore - € 240,00" },
        { sku: "TACCA04", name: "Telecomando 1 canale - € 80,00" },
        { sku: "TACCA05", name: "Telecomando 5 canali - € 115,00" }
      ].map((opt) => (
        <FormControlLabel
          key={opt.sku}
          className="w-full mt-2"
          control={
            <Checkbox
              checked={accessori.some((a) => a.sku === opt.sku)}
              onChange={(e) => {
                const updated = e.target.checked
                  ? [...accessori.filter(a => a.sku !== opt.sku), { sku: opt.sku, notes: "" }]
                  : accessori.filter(a => a.sku !== opt.sku);
                handleChange("accessori", updated);
              }}
              sx={{ marginTop: 0, marginBottom: 0 }}
            />
          }
          label={opt.name}
          sx={{ marginTop: 0, marginBottom: 0 }}
        />
      ))}*/}
    </>
  );
};
